import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getEquipos = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/equipos?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const getEquiposEstado = async (estado) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/equipos/estado?empresa=${userInfo.empresa}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearEquipo = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/equipos', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateEquipo = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/equipos/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteEquipo = (Id) => Axios.delete(`/equipos/${Id}`);
